import { render, staticRenderFns } from "./MegaMenu2.vue?vue&type=template&id=e3787b12"
import script from "./MegaMenu2.vue?vue&type=script&lang=js"
export * from "./MegaMenu2.vue?vue&type=script&lang=js"
import style0 from "./MegaMenu2.vue?vue&type=style&index=0&id=e3787b12&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports